import { render, staticRenderFns } from "./VariantSelect.vue?vue&type=template&id=00c165b2&scoped=true"
import script from "./VariantSelect.vue?vue&type=script&lang=js"
export * from "./VariantSelect.vue?vue&type=script&lang=js"
import style0 from "./VariantSelect.vue?vue&type=style&index=0&id=00c165b2&prod&lang=scss&scoped=true"
import style1 from "./VariantSelect.vue?vue&type=style&index=1&id=00c165b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c165b2",
  null
  
)

export default component.exports